import { render } from "./VehicleDashboard.vue?vue&type=template&id=30c6caff&scoped=true"
import script from "./VehicleDashboard.vue?vue&type=script&lang=js"
export * from "./VehicleDashboard.vue?vue&type=script&lang=js"

import "./VehicleDashboard.vue?vue&type=style&index=0&id=30c6caff&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c6caff"]])

export default __exports__